<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<form [formGroup]="addEmployeeEmailForm" (ngSubmit)="onSubmit()" id="addEmployeeEmailFormID" fxFlex>
  <div>
    <!-- Details -->
    <mat-card style="box-shadow: none">
      <mat-card-header fxLayoutAlign="start center">
        <div fxLayout="row">
          <mat-card-title i18n="add email label@@addEmailLabel">Add Email</mat-card-title>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="formelement_container" fxLayout="row">
          <mat-form-field id="employee_email" appearance="outline">
            <mat-label i18n="label for input field@@email">E-Mail</mat-label>
            <input matInput placeholder="" formControlName="email" id="email" required />
            <mat-error
              *ngIf="addEmployeeEmailForm.get('email')?.hasError('required')"
              i18n="Email is required@@emailIsRequired"
              >Email is required.</mat-error
            >
            <mat-error
              *ngIf="addEmployeeEmailForm.get('email')?.hasError('email')"
              i18n="Please enter a valid email@@pleaseEnterAValidEmail"
              >Please enter a valid email.</mat-error
            >
          </mat-form-field>
        </div>
        <span>{{ message }}</span>
      </mat-card-content></mat-card
    >
  </div>
  <div fxLayoutAlign="end end" style="padding: 20px">
    <div class="action_buttons">
      <button
        id="add_employee"
        class="button_save"
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="!addEmployeeEmailForm.valid"
        form="addEmployeeEmailFormID"
        i18n="button text add@@buttonAdd"
      >
        ADD
      </button>
      <button
        id="delete_employee"
        class="button_delete"
        mat-stroked-button
        (click)="onCancel()"
        type="button"
      >
        <span i18n="button text cancel@@buttonCancel">CANCEL</span>
      </button>
    </div>
  </div>
</form>
